export const tachesBasePath = 'taches';
export const listeDossierTachesPath = '/taches/dossiers';
export const listeTiersTachesPath = '/taches/prescripteurs';
export const listeUserTachesPath = '/taches/mes-taches';
